import {RouteRecordRaw} from "vue-router";
import CardlessDetectionControlView from "@/cardless/views/CardlessDetectionControlView.vue";

const routes: RouteRecordRaw[] = [
    {
        path: '/cardless-detection/control',
        name: 'cardless-detection-control',
        component: CardlessDetectionControlView,
        meta: {
            title: 'Contrôle de la détection sans carte',
            layout: 'TheBlankLayout'
        }
    }
];

export default routes;
